import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MetaTags from "react-meta-tags";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Label,
  Input,
  Button,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { SERVER_URL } from "../ServerLink";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import axios from "../api/axios";
import jwt_decode from "jwt-decode";

// ─── Sub-components defined OUTSIDE Setting so they are never recreated ────────

const DropzoneSection = ({ selectedFiles, handleAcceptedFiles, removeDocuments }) => (
  <div className="col-lg-12">
    <div className="mb-3">
      <Dropzone onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)}>
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone">
            <div className="dz-message needsclick mt-2" {...getRootProps()}>
              <input {...getInputProps()} />
              <div className="mb-3">
                <i className="display-4 text-muted bx bxs-cloud-upload" />
              </div>
              <h4>Drop files here or click to upload.</h4>
            </div>
          </div>
        )}
      </Dropzone>
      <div className="dropzone-previews mt-3" id="file-previews">
        {selectedFiles.map((f, i) => (
          <Card
            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
            key={i + "-file"}
          >
            <div className="p-2">
              <Row className="align-items-center">
                <Col className="col-auto">
                  <img
                    data-dz-thumbnail=""
                    height="80"
                    className="avatar-sm rounded bg-light"
                    alt={f.name}
                    src={f.preview ? f.preview : f}
                  />
                </Col>
                <Col>
                  <Link to="#" className="text-muted font-weight-bold">{f.name}</Link>
                  <p className="mb-0"><strong>{f.formattedSize}</strong></p>
                </Col>
                <Col className="trash-btn">
                  <button
                    type="button"
                    onClick={() => removeDocuments(i)}
                    className="btn btn-soft-danger waves-effect waves-light"
                  >
                    <i className="bx bx-trash-alt"></i>
                  </button>
                </Col>
              </Row>
            </div>
          </Card>
        ))}
      </div>
    </div>
  </div>
);

const ChangePasswordCard = ({
  oldPassword, setOldPassword,
  password, setPassword,
  confirmPassword, setConfirmPassword,
  showPassword, setShowPassword,
  showConfirmPassword, setShowConfirmPassword,
  passwordLoading,
  changePassword,
}) => (
  <Row>
    <Col xl={12}>
      <Card>
        <CardHeader>
          <h4 className="card-title">Change Password</h4>
          <p className="card-title-desc">At least 8 characters, upper and lower case letters</p>
        </CardHeader>
        <CardBody>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="mb-3">
                <Label className="form-label" htmlFor="oldPwdInput">Old Password</Label>
                <Input
                  id="oldPwdInput"
                  onChange={(e) => setOldPassword(e.target.value)}
                  type="password"
                  className="form-control"
                  value={oldPassword}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3 d-flex">
                <div className="w-100">
                  <Label htmlFor="newPwdInput">Password</Label>
                  <div className="passwordToggle w-100">
                    <Input
                      className="w-100 form-control"
                      id="newPwdInput"
                      onChange={(e) => setPassword(e.target.value)}
                      type={showPassword ? "text" : "password"}
                      value={password}
                    />
                    <div className="passwordToggleEye">
                      <button
                        className="btn btn-light shadow-none ms-0"
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className={showPassword ? "bx bx-show" : "bx bxs-low-vision"}></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3 d-flex">
                <div className="w-100">
                  <Label className="form-label" htmlFor="confirmPwdInput">Confirm Password</Label>
                  <div className="passwordToggle w-100">
                    <Input
                      id="confirmPwdInput"
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      value={confirmPassword}
                    />
                    <div className="passwordToggleEye">
                      <button
                        className="btn btn-light shadow-none ms-0"
                        type="button"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      >
                        <i className={showConfirmPassword ? "bx bx-show" : "bx bxs-low-vision"}></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="mt-4">
                <button type="submit" onClick={changePassword} className="btn btn-primary mr-10 w-md">
                  {passwordLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" style={{ marginRight: "3px" }} role="status" aria-hidden="true"></span>
                      Loading...
                    </>
                  ) : (
                    <div>Change password</div>
                  )}
                </button>
                <span
                  id="messageSpan"
                  style={{ color: "red", fontWeight: "bolder", marginLeft: "10px", display: "none" }}
                ></span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

const GoogleSyncCard = ({ email, setEmail, syncLoading, syncWithGoogle, accessTokenExpirationTime }) => (
  <Row>
    <Col xl={12}>
      <Card>
        <CardHeader>
          <h4 className="card-title">Sync with Google Calendar</h4>
          <p className="card-title-desc">Connect your Google account to sync appointments to Google Calendar.</p>
        </CardHeader>
        <CardBody>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="mb-3">
                <Label className="form-label" htmlFor="googleAuthEmail">Auth Email</Label>
                <Input
                  id="googleAuthEmail"
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  className="form-control"
                  value={email}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mt-2">
                <Button
                  type="button"
                  style={{ backgroundColor: "#4285f4", border: "none", display: "flex", alignItems: "center" }}
                  onClick={syncWithGoogle}
                >
                  {syncLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm" style={{ marginRight: "3px" }} role="status" aria-hidden="true"></span>
                      Loading...
                    </>
                  ) : (
                    <>
                      <span style={{ color: "white" }}>Sync</span>
                      <div style={{ height: "24px", width: "27px", borderRadius: "50%" }}>
                        <img src="/images/google.png" alt="Google Logo" style={{ height: "21px" }} />
                      </div>
                    </>
                  )}
                </Button>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-6">
              <div className="mb-3">
                <Label className="form-label">Access Token Expiration Time</Label>
                <Input
                  type="text"
                  readOnly
                  value={accessTokenExpirationTime || ""}
                  className="form-control"
                />
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

const formatExpiry = (ms) => {
  if (!ms) return null;
  try {
    return new Date(ms).toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return null;
  }
};

const daysUntil = (ms) => {
  if (!ms) return null;
  const diff = ms - Date.now();
  if (diff <= 0) return 0;
  return Math.ceil(diff / (24 * 60 * 60 * 1000));
};

const OutlookSyncCard = ({
  outlookConnected,
  outlookConnecting,
  outlookEmail,
  outlookExpiry,
  connectOutlook,
  disconnectOutlook,
}) => {
  const expiryLabel = formatExpiry(outlookExpiry);
  const remainingDays = daysUntil(outlookExpiry);
  const isExpiringSoon = remainingDays !== null && remainingDays <= 5;

  return (
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <h4 className="card-title">Sync with Outlook Calendar</h4>
            <p className="card-title-desc">Connect your Microsoft account to sync appointments and scheduled tickets to your Outlook Calendar. Access is saved for 30 days at a time.</p>
          </CardHeader>
          <CardBody>
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="d-flex align-items-center gap-3 flex-wrap">
                  {outlookConnected ? (
                    <>
                      <span className="badge bg-success fs-6 px-3 py-2">
                        <i className="bx bx-check me-1"></i> Outlook Connected
                      </span>
                      <Button type="button" color="danger" outline onClick={disconnectOutlook}>
                        Disconnect Outlook
                      </Button>
                    </>
                  ) : (
                    <Button
                      type="button"
                      style={{ backgroundColor: "#0078d4", border: "none", display: "flex", alignItems: "center", gap: "8px" }}
                      onClick={connectOutlook}
                      disabled={outlookConnecting}
                    >
                      {outlookConnecting ? (
                        <>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Connecting...
                        </>
                      ) : (
                        <>
                          <img src="/images/outlook.png" alt="Outlook Logo" style={{ height: "20px" }} />
                          <span style={{ color: "white" }}>Connect Outlook</span>
                        </>
                      )}
                    </Button>
                  )}
                </div>
                {outlookConnected && (
                  <div className="mt-2">
                    {outlookEmail && (
                      <p className="text-muted mb-1" style={{ fontSize: "0.85rem" }}>
                        <i className="bx bx-envelope me-1"></i>
                        Linked account: <strong>{outlookEmail}</strong>
                      </p>
                    )}
                    {expiryLabel && (
                      <p
                        className={`mb-0 ${isExpiringSoon ? "text-danger" : "text-muted"}`}
                        style={{ fontSize: "0.85rem" }}
                      >
                        <i className="bx bx-time me-1"></i>
                        Access valid until <strong>{expiryLabel}</strong>
                        {remainingDays !== null && (
                          <span className="ms-1">
                            ({remainingDays === 0
                              ? "expires today"
                              : `${remainingDays} day${remainingDays === 1 ? "" : "s"} remaining`})
                          </span>
                        )}
                        {isExpiringSoon && (
                          <span className="ms-1">— reconnect soon to avoid interruption.</span>
                        )}
                      </p>
                    )}
                  </div>
                )}
                {!outlookConnected && (
                  <p className="text-muted mt-2 mb-0" style={{ fontSize: "0.85rem" }}>
                    Once connected, accepted appointments and scheduled maintenance tickets will auto-sync to your Outlook calendar.
                  </p>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

// ─── Main Setting Component ────────────────────────────────────────────────────

const Setting = () => {
  const location = useLocation();
  const decode = jwt_decode(window.localStorage.accessToken);

  const [email, setEmail] = useState("");
  const [accessTokenExpirationTime, setAccessTokenExpirationTime] = useState(null);

  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checked, setchecked] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(decode.twoFactorEnabled || false);
  const [username, setUsername] = useState(decode.username || "");
  const [firstname, setFirstName] = useState(decode.firstname || "");
  const [lastname, setLastName] = useState(decode.lastname || "");
  const [companyName, setCompanyName] = useState(decode.company || "");
  const [timezone, setTimezone] = useState(decode.timezone || "");
  const [street, setStreet] = useState(decode.address?.street || "");
  const [city, setCity] = useState(decode.address?.city || "");
  const [province, setProvince] = useState(decode.address?.province || "");
  const [postalCode, setPostalCode] = useState(decode.address?.postal_code || "");
  const [country, setCountry] = useState(decode.address?.country || "");

  const [profileLoading, setProfileLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [outlookConnected, setOutlookConnected] = useState(false);
  const [outlookConnecting, setOutlookConnecting] = useState(false);
  const [outlookEmail, setOutlookEmail] = useState(null);
  const [outlookExpiry, setOutlookExpiry] = useState(null);

  const [selectedFiles, setselectedFiles] = useState(
    decode.profile ? [`${SERVER_URL}/${decode.profile}`] : []
  );

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleTwoFactorToggle = (enabled) => {
    setTwoFactorEnabled(enabled);
  };

  function updateToken(token) {
    window.localStorage.removeItem("accessToken");
    window.localStorage.setItem("accessToken", token);
  }

  useEffect(() => {
    if (checked === false) {
      const data = { email: window.localStorage.getItem("email"), role: decode.role };
      axios.post("/two-fa/disable-link", data).then(() => { }).catch(() => { });
    }
    if (checked === true) {
      const data = { email: window.localStorage.getItem("email"), role: decode.role };
      axios.post("/two-fa/enable", data).then(() => { }).catch(() => { });
    }
  }, [checked]);

  function displaySuccessMessage(message, token) {
    const messageSpan = document.getElementById("updateMessageSpan");
    updateToken(token);
    messageSpan.innerText = message;
    messageSpan.style.color = "green";
    messageSpan.style.display = "inline-block";
  }

  function displayFailureMessage(message) {
    const messageSpan = document.getElementById("updateMessageSpan");
    messageSpan.innerText = message;
    messageSpan.style.color = "red";
    messageSpan.style.display = "inline-block";
  }

  const uploadDocuments = async (id) => {
    if (selectedFiles.length > 0 && !selectedFiles[0]?.preview) return;
    const formData = new FormData();
    selectedFiles.forEach((file) => formData.append("file", file));
    const config = {
      headers: { "content-type": "multipart/form-data", id: `${id}`, role: decode.role },
    };
    try {
      await axios.post("/settings/upload-documents", formData, config);
    } catch (error) { }
  };

  const getExpirationTime = async () => {
    try {
      const response = await axios.post(`/calender/getExpirationTime/${decode.id}`);
      if (response.status === 200) {
        const expirationTime = parseInt(response.data.token.expiresAt);
        setAccessTokenExpirationTime(new Date(expirationTime).toLocaleString());
      }
    } catch (error) { }
  };

  const checkOutlookStatus = async () => {
    try {
      const { data } = await axios.get(`/outlook/status/${decode.id}`);
      setOutlookConnected(!!data.connected);
      setOutlookEmail(data.email || null);
      setOutlookExpiry(data.expiry || null);
    } catch {
      setOutlookConnected(false);
      setOutlookEmail(null);
      setOutlookExpiry(null);
    }
  };

  const connectOutlook = () => {
    setOutlookConnecting(true);

    const popup = window.open(
      `${SERVER_URL}/outlook/auth?userId=${decode.id}`,
      "OutlookOAuth",
      "width=600,height=700"
    );

    if (!popup) {
      setOutlookConnecting(false);
      toast.error("Popup was blocked. Please allow popups and try again.");
      return;
    }

    const pollTimer = setInterval(() => {
      if (popup.closed) {
        clearInterval(pollTimer);
        clearTimeout(hardTimeout);
        setTimeout(() => {
          setOutlookConnecting((stillConnecting) => {
            if (stillConnecting) {
              setOutlookConnecting(false);
            }
            return false;
          });
        }, 300);
      }
    }, 500);

    const hardTimeout = setTimeout(() => {
      clearInterval(pollTimer);
      if (!popup.closed) popup.close();
      setOutlookConnecting(false);
      toast.error("Connection timed out. Please try again.");
    }, 5 * 60 * 1000);
  };

  const disconnectOutlook = async () => {
    try {
      await axios.post(`/outlook/disconnect/${decode.id}`);
      setOutlookConnected(false);
      setOutlookEmail(null);
      setOutlookExpiry(null);
      toast.success("Outlook disconnected.");
    } catch {
      toast.error("Failed to disconnect Outlook.");
    }
  };

  async function updateProfileInformation(e, role) {
    e.preventDefault();
    setProfileLoading(true);
    document.getElementById("updateMessageSpan").style.display = "none";

    const basePayload = {
      role: decode.role,
      userID: decode.id,
      username,
      firstname,
      lastname,
      timezone,
      twoFactorEnabled,
    };

    try {
      await uploadDocuments(decode.id);

      let response;
      if (role === "company") {
        response = await axios.post("/settings/edit-information", { ...basePayload, companyName });
      } else if (role === "manager") {
        response = await axios.post("/settings/edit-information", {
          ...basePayload,
          address: { street, city, province, postal_code: postalCode, country },
        });
      } else {
        response = await axios.post("/settings/edit-information", basePayload);
      }

      const { status, message, accessToken } = response.data;
      if (status === 200 || status === 201) {
        displaySuccessMessage(message, accessToken);
        window.location.replace("/setting");
      } else if (status === 409) {
        displayFailureMessage(message);
      }
    } catch (error) {
      displayFailureMessage("Something went wrong !");
    } finally {
      setProfileLoading(false);
    }
  }

  function handleAcceptedFiles(files) {
    files.forEach((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
  }

  const removeDocuments = (idToRemove) => {
    setselectedFiles((prev) => prev.filter((_, i) => i !== idToRemove));
  };

  async function changePassword(e) {
    e.preventDefault();
    const messageSpan = document.getElementById("messageSpan");
    messageSpan.style.display = "none";

    if (!oldPassword) {
      messageSpan.innerText = "Please enter old password";
    } else if (!password) {
      messageSpan.innerText = "Please enter new password";
    } else if (!confirmPassword) {
      messageSpan.innerText = "Please enter confirm password";
    } else if (password !== confirmPassword) {
      messageSpan.innerText = "Confirm Password doesn't match !";
    }

    if (!oldPassword || !password || !confirmPassword || password !== confirmPassword) {
      messageSpan.style.color = "red";
      messageSpan.style.display = "inline-block";
      return;
    }

    try {
      setPasswordLoading(true);
      const response = await axios.post("/settings/change-password", {
        role: decode.role,
        userID: decode.id,
        oldPassword,
        password,
        confirmPassword,
      });
      if (response.data.status === 201) {
        messageSpan.innerText = response.data.message;
        messageSpan.style.color = "green";
        messageSpan.style.display = "inline-block";
        setOldPassword("");
        setPassword("");
        setConfirmPassword("");
      }
      if (response.data.status === 409) {
        messageSpan.innerText = response.data.message;
        messageSpan.style.color = "red";
        messageSpan.style.display = "inline-block";
      }
    } catch (error) {
      messageSpan.innerText = "Something went wrong !";
      messageSpan.style.color = "red";
      messageSpan.style.display = "inline-block";
    } finally {
      setPasswordLoading(false);
    }
  }

  const syncWithGoogle = async () => {
    try {
      setSyncLoading(true);
      const response = await axios.post("/calender/googleAuth", {
        userId: decode.id,
        companyId: decode.companyId || decode.id,
        firstname: decode.firstname,
        lastname: decode.lastname,
        authEmail: email,
        role: decode.role,
      });
      if (response.data) window.location.href = response.data;
    } catch (error) {
    } finally {
      setSyncLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const response = params.get("response");
    const parsedResponse = response ? JSON.parse(response) : null;
    if (response && parsedResponse) {
      toast.success(parsedResponse.message);
      const updatedParams = new URLSearchParams(location.search);
      updatedParams.delete("response");
      const updatedSearch = updatedParams.toString();
      window.history.replaceState(
        null, "",
        updatedSearch ? `${location.pathname}?${updatedSearch}` : location.pathname
      );
    }
  }, [location.search]);

  useEffect(() => {
    getExpirationTime();
    checkOutlookStatus();
  }, []);

  useEffect(() => {
    const handler = (e) => {
      if (e.data?.type === "OUTLOOK_CONNECTED") {
        checkOutlookStatus();
        setOutlookConnecting(false);
        toast.success("Outlook calendar connected!");
      }
      if (e.data?.type === "OUTLOOK_ERROR") {
        setOutlookConnecting(false);
        toast.error(e.data?.message || "Failed to connect Outlook. Please try again.");
      }
    };
    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  const dropzoneProps = { selectedFiles, handleAcceptedFiles, removeDocuments };

  const passwordCardProps = {
    oldPassword, setOldPassword,
    password, setPassword,
    confirmPassword, setConfirmPassword,
    showPassword, setShowPassword,
    showConfirmPassword, setShowConfirmPassword,
    passwordLoading,
    changePassword,
  };

  const googleCardProps = { email, setEmail, syncLoading, syncWithGoogle, accessTokenExpirationTime };

  const outlookCardProps = { outlookConnected, outlookConnecting, outlookEmail, outlookExpiry, connectOutlook, disconnectOutlook };

  const UpdateProfileButton = () => (
    <div className="col-lg-12">
      <div className="mt-4">
        <button
          type="submit"
          onClick={(e) => updateProfileInformation(e, decode.role)}
          className="btn btn-primary mr-10 w-md"
        >
          {profileLoading ? (
            <>
              <span className="spinner-border spinner-border-sm" style={{ marginRight: "3px" }} role="status" aria-hidden="true"></span>
              Loading...
            </>
          ) : (
            <div>Update Profile</div>
          )}
        </button>
        <span id="updateMessageSpan" style={{ color: "red", fontWeight: "bolder", marginLeft: "10px", display: "none" }}></span>
      </div>
    </div>
  );

  const TimezoneSelect = () => (
    <div className="col-lg-3">
      <div className="mb-3">
        <Label className="form-Label">Time Zone</Label>
        <select onChange={(e) => setTimezone(e.target.value)} className="form-select" value={timezone}>
          <option value="">{decode.timezone ? `Current: ${timezone}` : "Select"}</option>
          <option>CA/Newfoundland</option>
          <option>CA/Atlantic</option>
          <option>CA/Central</option>
          <option>CA/Eastern</option>
          <option>CA/Mountain</option>
          <option>CA/Pacific</option>
        </select>
      </div>
    </div>
  );

  const TwoFactorToggle = () => (
    <div className="col-lg-3">
      <div className="mb-3">
        <Label className="form-Label">Two Factor Enabled?</Label>
        <div className="form-check form-switch form-switch-lg mt-2">
          <Input
            type="checkbox"
            className="form-check-input"
            id="twoFactorSwitch"
            checked={twoFactorEnabled}
            onChange={(e) => handleTwoFactorToggle(e.target.checked)}
          />
          <Label className="form-check-label" htmlFor="twoFactorSwitch">
            {twoFactorEnabled ? "Enabled" : "Disabled"}
          </Label>
        </div>
      </div>
    </div>
  );

  // ── Render ────────────────────────────────────────────────────────────────────
  const role = decode.role;

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags><title>Profile Settings</title></MetaTags>
        <ToastContainer />
        <div className="container-fluid">
          <Breadcrumbs title="Home" breadcrumbItem="Profile Settings" />

          <Row>
            <Col xl={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title">Your Profile Details</h4>
                </CardHeader>
                <CardBody>
                  <div className="row align-items-center">

                    {/* ── Common: Username ── */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="formrow-username-input">User Name</Label>
                        <Input onChange={(e) => setUsername(e.target.value)} type="text" className="form-control" id="formrow-username-input" value={username} />
                      </div>
                    </div>

                    {/* ── Company-specific fields ── */}
                    {role === "company" && (
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <Label className="form-label">Company Name</Label>
                          <Input onChange={(e) => setCompanyName(e.target.value)} type="text" className="form-control" value={companyName} />
                        </div>
                      </div>
                    )}

                    {/* ── Manager: Associated Company ── */}
                    {role === "manager" && (
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <Label className="form-label">Associated Company</Label>
                          <Input type="text" className="form-control" value={decode.managerOf} disabled />
                        </div>
                      </div>
                    )}

                    {/* ── Common: Email (non-company shows here at top) ── */}
                    {role !== "company" && (
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="formrow-email-input">Email Address</Label>
                          <Input type="text" className="form-control" id="formrow-email-input" value={decode.email} disabled />
                        </div>
                      </div>
                    )}

                    {/* ── First Name ── */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="formrow-firstname-input">
                          {role === "company" ? "Owner First Name" : "First Name"}
                        </Label>
                        <Input onChange={(e) => setFirstName(e.target.value)} type="text" className="form-control" id="formrow-firstname-input" value={firstname} />
                      </div>
                    </div>

                    {/* ── Last Name ── */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <Label className="form-label" htmlFor="formrow-secondname-input">
                          {role === "company" ? "Owner Last Name" : "Last Name"}
                        </Label>
                        <Input onChange={(e) => setLastName(e.target.value)} type="text" className="form-control" id="formrow-secondname-input" value={lastname} />
                      </div>
                    </div>

                    {/* ── Company: Email shown after names ── */}
                    {role === "company" && (
                      <div className="col-lg-6">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="formrow-email-input">Email Address</Label>
                          <Input type="text" className="form-control" id="formrow-email-input" value={decode.email} disabled />
                        </div>
                      </div>
                    )}

                    {/* ── Timezone (not for admin-only-no-tz roles) ── */}
                    {(role === "admin" || role === "company" || role === "manager") && (
                      <TimezoneSelect />
                    )}

                    {/* ── Two Factor ── */}
                    <TwoFactorToggle />

                    {/* ── Manager: Address fields ── */}
                    {role === "manager" && (
                      <>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label className="form-label">Street</Label>
                            <Input onChange={(e) => setStreet(e.target.value)} type="text" className="form-control" value={street} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label className="form-label">City</Label>
                            <Input onChange={(e) => setCity(e.target.value)} type="text" className="form-control" value={city} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label className="form-label">Province</Label>
                            <Input onChange={(e) => setProvince(e.target.value)} type="text" className="form-control" value={province} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label className="form-label">Postal Code</Label>
                            <Input onChange={(e) => setPostalCode(e.target.value)} type="text" className="form-control" value={postalCode} />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mb-3">
                            <Label className="form-label">Country</Label>
                            <Input onChange={(e) => setCountry(e.target.value)} type="text" className="form-control" value={country} />
                          </div>
                        </div>
                      </>
                    )}

                    <DropzoneSection {...dropzoneProps} />
                    <UpdateProfileButton />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <ChangePasswordCard {...passwordCardProps} />

          {(role === "company" || role === "manager") && (
            <>
              <GoogleSyncCard {...googleCardProps} />
              <OutlookSyncCard {...outlookCardProps} />
            </>
          )}

          {role === "technical staff" && (
            <OutlookSyncCard {...outlookCardProps} />
          )}

        </div>
      </div>
    </React.Fragment>
  );
};

export default Setting;